import MainNav from './MainNav.vue'
import MainSide from './MainSide.vue'
import ScenarioItem from './ScenarioItem.vue'
import QrcodeReader from './QrcodeReader.vue'
import CountDown from './CountDown.vue'

export default{
  MainNav,
  MainSide,
  ScenarioItem,
  QrcodeReader,
  CountDown
}



// WEBPACK FOOTER //
// ./src/components/_index.js